import { render } from "./photonPersistentDisk.vue?vue&type=template&id=2fa06d58"
import script from "./photonPersistentDisk.vue?vue&type=script&lang=js"
export * from "./photonPersistentDisk.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../Users/onchainengineer/workbench/sourcecode/github_autonomy-cloud/dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__